let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8Npl5")).then(() => parcelRequire('9V8Ld'));